import { render, staticRenderFns } from "./electric-property-list.vue?vue&type=template&id=5d8bf9d6&scoped=true&"
import script from "./electric-property-list.vue?vue&type=script&lang=js&"
export * from "./electric-property-list.vue?vue&type=script&lang=js&"
import style0 from "./electric-property-list.vue?vue&type=style&index=0&id=5d8bf9d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8bf9d6",
  null
  
)

export default component.exports